import { parseJournal } from "../../services/journalMarkdown";

/**
 * Renders a journal entry's body (#468).
 *
 * THE PLATFORM HALF. services/journalMarkdown.js does the parsing and is
 * byte-identical to mobile's copy; this file turns its tokens into
 * elements and has a React Native twin that turns the same tokens into
 * <Text> and <View>. One parser, two renderers -- the only arrangement
 * in which both platforms can be relied on to read an entry the same
 * way.
 *
 * NOTHING HERE BUILDS HTML. No dangerouslySetInnerHTML, no sanitizer,
 * no markdown library. React escapes the text content of every element
 * it creates, so an entry containing <script> renders as the characters
 * "<script>". That matters most for #290, which sends journal text into
 * a PUBLIC composer -- the one place in this app where one person's
 * writing renders in another person's browser.
 *
 * Checkboxes are interactive only when onToggle is supplied, which is
 * only ever on the author's own entry. A teammate reading a shared
 * entry sees the ticks and cannot change them: it is somebody else's
 * list, and the server would refuse anyway.
 */
export function JournalBody({ body, onToggle }) {
  const blocks = parseJournal(body);

  return (
    <div style={{ margin: "var(--space-2) 0" }}>
      {blocks.map((block, i) =>
        block.type === "list" ? (
          <ul key={i} style={{ margin: "var(--space-1) 0", paddingLeft: "1.25rem",
                               listStyle: block.items.some((it) => it.checked !== null)
                                 ? "none" : "disc" }}>
            {block.items.map((item, j) => (
              <li key={j} style={{ marginLeft: item.checked !== null ? "-1.25rem" : 0 }}>
                {item.checked !== null && (
                  <input id="journal-body-checked" name="checked"
                    type="checkbox"
                    checked={item.checked}
                    /* Read-only for everyone but the author. `disabled`
                       rather than hidden, so a shared checklist still
                       SHOWS what has been done -- which is the useful
                       half of somebody else's list. */
                    disabled={!onToggle}
                    onChange={() => onToggle && onToggle(item.line)}
                    aria-label={spansToText(item.spans)}
                    style={{ marginRight: "var(--space-1)" }}
                  />
                )}
                <Spans spans={item.spans} />
              </li>
            ))}
          </ul>
        ) : (
          <p key={i} style={{ whiteSpace: "pre-wrap", margin: "var(--space-1) 0" }}>
            <Spans spans={block.spans} />
          </p>
        )
      )}
    </div>
  );
}

function Spans({ spans }) {
  return spans.map((s, i) =>
    s.type === "strong" ? <strong key={i}>{s.text}</strong>
      : s.type === "em" ? <em key={i}>{s.text}</em>
        : <span key={i}>{s.text}</span>);
}

/* A checkbox needs a name, and its label is the item's own text. Built
   from the spans rather than the raw line so the asterisks are not read
   out -- "star star smoker star star" is not a label. */
function spansToText(spans) {
  return spans.map((s) => s.text).join("");
}
